import { useContext } from "react";
import { Close as CloseIcon } from "@rshbintech.dboul/icons";
import { A11yChild } from "../../../../../a11y";
import { FileItemContext } from "../../providers";
import styles from "./styles.module.scss";

export const FileDelete = () => {
  const {
    removeButtonIndex = 0,
    a11yChildCurrentIndex,
    a11yChildRefWithIndex,
    file = { name: "" },
    dataTestId,
    handleFileDelete,
  } = useContext(FileItemContext);

  return (
    <A11yChild
      hasA11yFocus={a11yChildCurrentIndex === removeButtonIndex}
      a11yChildRef={a11yChildRefWithIndex?.(removeButtonIndex)}
    >
      <button
        onClick={handleFileDelete}
        className={styles["file-delete-button"]}
        data-test-id={`${dataTestId}-delete-button`}
        aria-label={`Удалить файл ${file.name}`}
      >
        <CloseIcon className={styles["close-icon"]} size="medium" />
      </button>
    </A11yChild>
  );
};
